import { Component, ElementRef, ViewChild, AfterViewInit, OnDestroy, OnInit } from '@angular/core';

import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-specialists-network',
  standalone: true,
  imports: [],
  templateUrl: './specialists-network.component.html',
  styleUrls: ['./specialists-network.component.css']
})
export class SpecialistsNetworkComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild('specialistsSection') specialistsSection!: ElementRef;

  isVisible = false;
  isMobile = false;

  private observer: IntersectionObserver | null = null;
  private breakpointSubscription: any;

  constructor(private breakpointObserver: BreakpointObserver) { }

  ngOnInit() {
    // Detecta si es móvil o tablet para cambiar el layout
    this.breakpointSubscription = this.breakpointObserver.observe([
      Breakpoints.Handset,
      Breakpoints.TabletPortrait
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });
  }

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
            if (this.observer) {
              this.observer.disconnect(); // Solo anima una vez
            }
          }
        });
      },
      { threshold: 0.3 }
    );

    if (this.specialistsSection?.nativeElement) {
      this.observer.observe(this.specialistsSection.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.observer) this.observer.disconnect();
    if (this.breakpointSubscription) this.breakpointSubscription.unsubscribe();
  }
}